<template>
  <div class="vx-row">
    <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters"
      :collapse-action="true">
      <div class="vx-row">
        <div class="w-full vx-col md:w-1/3 sm:w-1/2">
          <label class="text-sm opacity-100 text-bold">General Search</label>
          <vs-input type="text" v-model="filters['search']" class="w-full mb-4 md:mb-0" />
        </div>
        <div class="w-full vx-col md:w-1/3 sm:w-1/2" v-if="!id">
          <label class="text-sm text-bold">Company</label>
          <v-select @input="fetchLocationList()" :clearable="true" v-model="filters['Company']" :options="company_list" label="Name" :reduce="option => option._id"
            class="w-full">
          </v-select>
        </div>
        <div class="w-full vx-col md:w-1/3 sm:w-1/2">
          <label class="text-sm text-bold">Location</label>
          <v-select :clearable="true" v-model="filters['Location']" :options="location_list" label="Name" :reduce="option => option._id"
            class="w-full">
          </v-select>
        </div>
      </div>
      <div class="mt-5 vx-row">
        <div class="w-full ml-auto vx-col">
          <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
            v-on:click="filters = {}">CLEAR
          </vs-button>
        </div>
      </div>
    </vx-card>

    <vx-card title="" v-can:any="['view-food-safety-report', 'create-food-safety-report']">
      <template slot="actions">
        <div class="flex float-right">
          <div class="con-btns-user flex items-center justify-between">
            <div class="flex mb-4">
              <vs-button v-can="'create-food-safety-report'" @click="onClickCreateTenant" class="mr-4" color="primary"
                type="filled">New</vs-button>
              <vs-button @click="onClickGeneratedReports" class="mr-4" color="primary"
                type="border">Generated Reports</vs-button>
              <vs-button v-can="'view-food-safety-report'" @click="onClickRefresh" class="mr-0" color="success" type="border"
                icon-pack="feather" icon="icon-rotate-cw"></vs-button>
            </div>
          </div>
        </div>
      </template>
      <div slot="no-body" class="mt-4">
        <vs-table :max-items="(meta.pageSize) ? meta.pageSize : 20" id="tenants-table" :data="tenants_list"
          @sort="handleSort" :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

          <template slot="thead">
            <vs-th>Food Safety Report Code</vs-th>
            <vs-th>Date of Inspection</vs-th>
            <vs-th v-if="!id">Company</vs-th>
            <vs-th>Location</vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].Code">
                <span class="text-primary"> {{ data[indextr].Code || '-' }}</span>
              </vs-td>

              <vs-td :data="data[indextr].createdAt">
                {{ __dateTimeFormatter(data[indextr].createdAt) }}
              </vs-td>

              <vs-td v-if="!id">
                <span v-if="!!data[indextr].Company" @click.stop="onClickOpenCompany(data[indextr].Company._id)" class="cursor-pointer underline">
                  {{ data[indextr].Company.Name }}
                </span>
              </vs-td>

              <vs-td>
                <span v-if="!!data[indextr].Location" @click.stop="onClickOpenLocation(data[indextr].Location._id)" class="cursor-pointer underline">
                  {{ data[indextr].Location.Name }}
                </span>
              </vs-td>


              <vs-td>
                <div class="vx-row">
                  <vx-tooltip v-can="'update-food-safety-report'" class="mr-2" text="View & Update" position="top">
                    <vs-button @click.stop="onClickUpdate(data[indextr])" size="small" color="primary" type="border"
                      icon-pack="feather" icon="icon-eye"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip class="mr-2" text="Attachments" position="top" v-can="'update-food-safety-report'">
                    <vs-button @click.stop="onClickAttachments(data[indextr])" size="small" color="success" type="filled"
                      icon-pack="feather" icon="icon-file"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip class="mr-2" text="Action" position="top" v-can="'update-food-safety-report'">
                    <vs-button @click.stop="onClickOpenActions(data[indextr])" size="small" color="success" type="border"
                      icon-pack="feather" icon="icon-circle">Actions</vs-button>
                  </vx-tooltip>
                  <vx-tooltip class="mr-2" text="Generate Report" position="top" v-can="'view-food-safety-report'">
                    <vs-button @click.stop="onClickReportGenerate(data[indextr])" size="small" color="danger" type="filled"
                      icon-pack="feather" icon="icon-printer"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip class="mr-2" text="Delete Assessment" position="top" v-can="'delete-food-safety-report'">
                    <vs-button @click.stop="onClickDeleteConfirm(data[indextr]._id)" size="small" color="danger" type="border"
                      icon-pack="feather" icon="icon-trash-2"></vs-button>
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>


        </vs-table>
        <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.pageSize ? meta.pageSize : 20"
          :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
          description :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
          v-model="page" class="p-5">
        </vs-pagination>

      </div>
    </vx-card>
    <CreateWizardObjectPopUp ref="createWizardObjectPopUp" />
    <AssessmentReportGeneratePopUp ref="AssessmentReportGeneratePopUp" @openGeneratedReports="onClickGeneratedReports()"/>
    <AttachmentPopUp ref="AttachmentPopUp"/>
    <AssessmentActionsPopUp ref="AssessmentActionsPopUp"/>
    <GeneratedReportsPopUp ref="GeneratedReportsPopUp"/>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
import vSelect from 'vue-select'
const TenantRepository = RepositoryFactory.get('tenant')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { defaultPagination, perPageList, MASTER_TENANT_DOMAIN } from "@/constants/config";
import CreateWizardObjectPopUp from "@/components/popups/general/CreateWizardObjectPopUp.vue"
import AssessmentReportGeneratePopUp from "@/components/popups/generate-reports/AssessmentReportGeneratePopUp.vue"
import AttachmentPopUp from "@/components/popups/attachments/AttachmentPopUp.vue"
const ObjectRepository = RepositoryFactory.get('object')
const DropDownRepository = RepositoryFactory.get('drop_down')

import AssessmentActionsPopUp from "@/components/popups/assessment-actions/AssessmentActionsPopUp.vue"
import GeneratedReportsPopUp from "@/components/popups/generated-reports/GeneratedReportsPopUp.vue"

export default {
  name: 'FoodSafetyReportList',
  data() {
    return {
      tenants_list: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      id: null,
      object_name: 'foodsafetyreport',
      company_list: [],
      location_list : []
    }
  },
  async mounted() {
    this.id = this.$route.params.id
    if(!this.id) {
      await this.fetchCompanyList()
    }
    await this.fetchLocationList()
  },
  components: {
    'v-select': vSelect,
    CreateWizardObjectPopUp,
    AssessmentReportGeneratePopUp,
    AttachmentPopUp,
    AssessmentActionsPopUp,
    GeneratedReportsPopUp
  },
  methods: {
    async refreshData() {
      await this.fetchTenants()
    },
    async fetchTenants() {
      await this.$vs.loading({
        container: '#tenants-table',
        scale: 0.50
      });
      try {
        const { data } = (await TenantRepository.getFoodSafetyReportList(this.page, this.filterQuery, this.perPage, this.sort, this.id)).data
        this.tenants_list = data.data
        this.meta = data.pagination
        this.meta.last_page = Math.ceil(this.meta.totalRecords / this.meta.pageSize)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#tenants-table > .con-vs-loading')
    },
    async onClickCreateTenant() {
      await this.$refs.createWizardObjectPopUp.openPopup(this.object_name, 'create', this.id ? { Company: this.id } : {})
    },
    async onClickUpdate(data) {
      await this.$refs.createWizardObjectPopUp.openPopup(this.object_name, 'update', data)
    },
    async onClickRefresh() {
      await this.fetchTenants()
    },
    async onClickDeleteConfirm(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        acceptText: 'Delete',
        text: `Are you sure you want to delete this assessment?`,
        accept: this.onClickDelete,
        parameters: [ id ]
      })
    },
    async onClickDelete(params) {
      await this.$vs.loading({
        container: '#tenants-table',
        scale: 0.50
      });
      try {
        await ObjectRepository.deleteObject(this.object_name, params[0])
        this.fetchTenants()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#tenants-table > .con-vs-loading')
    },
    async onClickGeneratedReports() {
      await this.$refs.GeneratedReportsPopUp.openPopup(this.object_name)
    },
    filterQueryUpdate() {
      this.page = 1
      this.fetchTenants()
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchTenants()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchTenants()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    async onClickReportGenerate(data) {
      this.$refs.AssessmentReportGeneratePopUp.openPopup(data, this.object_name)
    },
    async onClickAttachments(data) {
      this.$refs.AttachmentPopUp.openPopup(data, this.object_name)
    },
    async onClickOpenActions(data) {
      this.$refs.AssessmentActionsPopUp.openPopup(data, this.object_name)
    },
    onClickOpenCompany(id) {
      const route = this.$router.resolve({ path: `/pages/companies/${id}` });
      window.open(route.href, '_blank');
    },
    onClickOpenLocation(id) {
      const route = this.$router.resolve({ path: `/pages/locations?open=${id}` });
      window.open(route.href, '_blank');
    },
    async fetchCompanyList() {
      try {
        const { data } = (await DropDownRepository.fetchObjectsList('account')).data
        this.company_list = data.data
      } catch (e) {
        console.log(e);
      }
    },
    async fetchLocationList() {
      try {
        this.location_list = []
        this.filters.Location = ''
        const { data } = (await DropDownRepository.fetchObjectsList('location', this.filters && this.filters.Company ? `account_id=${this.filters.Company}` : ``)).data
        this.location_list = data.data
      } catch (e) {
        console.log(e);
      }
    }
  },
  watch: {
    page() {
      this.fetchTenants()
    },
    perPage() {
      this.fetchTenants()
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
}
</script>


<style scoped>
</style>
